export const environment = {
    production: true,
    API_BASE: 'https://api.qa.pl.savinda.lk',
    PORTAL: 'https://qa.portal.savinda.lk',
    INK_KITCHEN_API_BASE: 'https://api.qa.pl.savinda.lk/ink-kitchen',
    cache: {
        maxSize: 5000,

        /**
         * Max Age
         *
         * @type string
         * @default 1h
         * @description TTL of the cache. Use the below format
         * 1d2h3m4s5u
         * - d - Days
         * - h - hours
         * - m - minutes
         * - s - seconds
         * - u - milliseconds
         */
        maxAge: '1d'
    },
}

